import {Tr} from "@/i18n/i18n";
import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import TextUtils from "@/utils/text-utils";
import {BasePanel} from "@/scenes.ui/base-panel";
import Container = Phaser.GameObjects.Container;
import {SquareButton} from "@/scenes.ui/square-button";
import {Fonts} from "@/constants/font";
import BaseSound = Phaser.Sound.BaseSound;
import SoundUtils from "@/utils/sound-utils";
import SpriteUtils from "@/utils/sprite-utils";

export class ImageTextPanel extends BasePanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement, x: number, y: number, titleText: string, text: string,
                atlasKey: string, imageKey: string, clickSound: BaseSound | undefined, container?: Container) {
        super(scene, canvas, x, y, container);
        this.setDepth(2001);

        const self = this;

        let background = SpriteUtils.addSprite(this.scene, 0, 0, Keys.ATLAS_UI, Keys.UI_BLACK).setInteractive();
        SpriteUtils.setDispSize(background, canvas!.width * 2, canvas!.height * 2);

        const window = SpriteUtils.addImage(this.scene, 0, 15, Keys.UI_WINDOW_MIDDLE).setOrigin(0.5, 0.5);

        const image = SpriteUtils.addImage(this.scene, 0, -5, atlasKey, imageKey).setOrigin(0.5, 0.5);

        const xButton = SpriteUtils.addImage(this.scene, 178, -216, Keys.ATLAS_PROFILE, Keys.UI_ART_X).setOrigin(0.5, 0.5);

        xButton.setInteractive().on('pointerup', function() {
            SoundUtils.play(clickSound);
            self.close();
        });

        const title = TextUtils.addTextByFamily(this.scene, titleText, 0, -194, '#ffffff', 16,
            'normal', 420, Fonts.ARIAL_MT)
            .setOrigin(0.5, 0.5);

        let mainText = TextUtils.addTextByFamily(scene, text,
            0, -100, '#ffe9cf', 16, 'normal', 320, Fonts.ARIAL_MT);

        let okButton = new SquareButton(this.scene, 0, 120, 0, Keys.UI_ART_BROWN_BUTTON,
            Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, Tr('horosho'), false);

        okButton.setCallback(() => {
            if (this.isOnTop()) {
                SoundUtils.play(clickSound);
                this.close();
            }
        });

        this.add([background, window, image, xButton, title, mainText, okButton]);
    }

}
